module.exports = __webpack_public_path__ + "img/horizontal_6_1_pp1_6005.39ee74f2.png";